import classNames from 'classnames';
import styles from './Checkbox.module.scss';

/**
 * Checkbox
 *
 * @return {JSX.Element}
 */
const Checkbox = ({
  onChange,
  className,
  children,
  readOnly,
  disabled,
  style,
  toggler,
  reverse,
  fullWidth,
  displayFlex,
  horizontalPadding,
  verticalPadding,
  padding,
  rounded,
  onSurface,
  lineThrough,
  tabIndex = 0,
  ...rest
}) => {
  return (
    <label
      className={classNames(
        styles.Checkbox,
        readOnly && styles.Checkbox__readOnly,
        disabled && styles.Checkbox__disabled,
        toggler && styles.Checkbox__toggler,
        reverse && styles.Checkbox__reverse,
        fullWidth && styles.Checkbox__fullWidth,
        displayFlex && styles.Checkbox__displayFlex,
        horizontalPadding && styles.Checkbox__horizontalPadding,
        verticalPadding && styles.Checkbox__verticalPadding,
        padding && styles.Checkbox__padding,
        rounded && styles.Checkbox__rounded,
        onSurface && styles.Checkbox__onSurface,
        lineThrough && styles.Checkbox__lineThrough,
        Checkbox.displayName,
        className
      )}
      style={style}
    >
      <input
        {...rest}
        tabIndex={readOnly || disabled ? -1 : tabIndex}
        type="checkbox"
        onChange={readOnly ? undefined : onChange}
        readOnly={readOnly}
        disabled={readOnly || disabled}
      />
      <span className={styles.Visualizer} />
      {children && <span className={styles.Content}>{children}</span>}
    </label>
  );
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
